import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A centered modal dialog built on the native <dialog> element: opens in the
 * top layer with a backdrop, closes on Escape (the browser's 'cancel' event)
 * and on a backdrop click. `className` styles the panel itself.
 */
var CenteredDialog = function CenteredDialog(_ref) {
  var onClose = _ref.onClose,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dialogRef = useRef(null);
  useEffect(function () {
    var dialog = dialogRef.current;
    if (dialog && !dialog.open) {
      dialog.showModal();
    }
    var handleCancel = function handleCancel(event) {
      event.preventDefault();
      onClose();
    };
    dialog === null || dialog === void 0 || dialog.addEventListener('cancel', handleCancel);
    return function () {
      dialog === null || dialog === void 0 || dialog.removeEventListener('cancel', handleCancel);
    };
  }, [onClose]);
  var handleClick = function handleClick(event) {
    // Close when the backdrop (the dialog element itself) is clicked.
    if (event.target === dialogRef.current) {
      onClose();
    }
  };
  return /*#__PURE__*/_jsx("dialog", _objectSpread(_objectSpread({}, rest), {}, {
    ref: dialogRef,
    onClick: handleClick,
    className: twMerge('fixed inset-x-0 top-1/2 m-0 mx-auto box-border w-full max-w-99 -translate-y-1/2 backdrop:bg-black/70', className),
    children: children
  }));
};
export default CenteredDialog;